import addMinutes from 'date-fns/addMinutes';
import formatDate from 'date-fns/format';
function* generateInterval(startDate, intervalPeriod) {
  yield startDate;
  let prevDate = startDate;
  let newDate = addMinutes(startDate, intervalPeriod);
  while (prevDate.getDay() === newDate.getDay()) {
    yield newDate;
    var _ref = [newDate, addMinutes(newDate, intervalPeriod)];
    prevDate = _ref[0];
    newDate = _ref[1];
  }
}
function formatLocale(date, timeFormat) {
  return {
    label: formatDate(date, timeFormat),
    value: formatDate(date, timeFormat)
  };
}
export function generateTimeIntervals(intervalPeriod, format) {
  const startDate = new Date(1970, 0, 1, 0, 0, 0);
  const dates = [];
  const intervalGenerator = generateInterval(startDate, intervalPeriod);
  let interval = intervalGenerator.next();
  while (!interval.done) {
    dates.push(formatLocale(interval.value, format));
    interval = intervalGenerator.next();
  }
  return dates;
}